import env from '@beam-australia/react-env';

export function getConfig() {
  return {
    CMS_URL: env('CMS_URL') || 'http://localhost:1337',
    MEDIA_URL: env('MEDIA_URL') || 'http://localhost:1337',
    SENTRY_DSN: env('SENTRY_DSN'),
  };
}
